// extracted by mini-css-extract-plugin
export default {"editBackBtn":"EditDepartmentPage_editBackBtn__3gg3q"};